import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

let FilePreview: any = (props: any) => (
  <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H13C12.59 21.75 12.2 21.44 11.86 21.1C11.53 20.77 11.25 20.4 11 20H6V4H13V9H18V10.18C18.71 10.34 19.39 10.61 20 11V8L14 2ZM20.31 18.9C21.64 16.79 21 14 18.91 12.68C16.8 11.35 14 12 12.69 14.08C11.35 16.19 12 18.97 14.09 20.3C15.55 21.23 17.41 21.23 18.88 20.32L22 23.39L23.39 22L20.31 18.9ZM16.5 19C15.837 19 15.2011 18.7366 14.7322 18.2678C14.2634 17.7989 14 17.163 14 16.5C14 15.837 14.2634 15.2011 14.7322 14.7322C15.2011 14.2634 15.837 14 16.5 14C17.163 14 17.7989 14.2634 18.2678 14.7322C18.7366 15.2011 19 15.837 19 16.5C19 17.163 18.7366 17.7989 18.2678 18.2678C17.7989 18.7366 17.163 19 16.5 19Z" />
  </SvgIcon>
);
FilePreview.muiName = 'SvgIcon';

FilePreview = React.memo(FilePreview);
FilePreview.displayName = 'FilePreview';

const PureFilePreview = FilePreview;

export default PureFilePreview;
